import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BetsButton from '../Vets/Button';
import { selectSolanaUSDCBalance } from '../../redux/slices/walletSlice';
import { Container, ModalContainer } from '../BaseModal';
import { formatUSD } from '../../common/currency';
import BackButton from '../BackButton';

const ButtonsContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  gap: 20px;
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.text.title};
  font-size: 40px;
  font-weight: 600;
  font-family: Manrope;
`;

const YourBalanceLabel = styled.p`
  color: ${({ theme }) => theme.text.regular};
  font-size: 16px;
  font-weight: 400;
  font-family: Manrope;
  margin-top: 10px;
  margin-bottom: -5px;
`;

const VetsBalance = styled.p`
  color: ${({ theme }) => theme.text.regular};
  font-size: 36px;
  font-weight: 600;
  font-family: Manrope;
`;

const ManageUsd = () => {
  const usdcBalance = useSelector(selectSolanaUSDCBalance);

  const navigate = useNavigate();

  return (
    <Container>
      <ModalContainer>
        <BackButton />
        <div>
          <Title>USD</Title>
        </div>
        <div>
          <YourBalanceLabel>Your Balance</YourBalanceLabel>
          <VetsBalance>{formatUSD(usdcBalance)}</VetsBalance>
        </div>
        <ButtonsContainer>
          <BetsButton
            fullWidth
            onClick={() => {
              navigate('/app/deposit-selection');
            }}
          >
            DEPOSIT
          </BetsButton>
          <BetsButton
            secondary
            fullWidth
            onClick={() => {
              navigate('/app/withdraw-selection');
            }}
          >
            CASH OUT
          </BetsButton>
        </ButtonsContainer>
      </ModalContainer>
    </Container>
  );
};

export default ManageUsd;
